
import { AfterViewInit, Component, ElementRef, HostListener, Input, viewChild } from '@angular/core';
import { environment } from '../../../../environments/environment.prod';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { CommonService } from '../../../services/common.service';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { EditorTextComponent } from '../../../home/editor-text/editor-text.component';



@Component({
  selector: 'calsoft-zigzagimage1',
  imports: [DefaultLayoutDirective, ContentAnimDirective  ,CustomFlexLayoutModule, DefaultLayoutAlignDirective, EditorTextComponent, DefaultStyleDirective, DefaultFlexDirective],
  templateUrl: './zigzagimage1.component.html',
  styleUrl: './zigzagimage1.component.scss'
})
export class Zigzagimage1Component  implements AfterViewInit {
  constructor(  private commonService: CommonService){}
   @Input() data : any;
   @Input() item : any;
   @Input() images : any;
   public bannerServerPath = environment.commonImageApi + '/commonSlider/';
    
   public serverPath1 = environment.commonImageApi + '/home/';

  readonly storyContainer = viewChild.required<ElementRef>('storyContainer');

  successStories = [
    { image: 'assets/images/google-meet-people.jpg', title: 'Official Website of Tulsa Airport', description: 'Tulsa Airport, a prominent name in aviation, sought Cubix’s expertise to enhance its digital presence.' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 2', description: 'Project 2 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 3', description: 'Project 3 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 4', description: 'Project 4 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 5', description: 'Project 5 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 6', description: 'Project 6 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 7', description: 'Project 7 description...' },
    { image: 'assets/images/google-meet-people.jpg', title: 'Project 8', description: 'Project 8 description...' }
  ];

  ngAfterViewInit(): void {
    this.observeImages();
  }
  link(url: any) {

    this.commonService.goToLink(url)
   
  }


  observeImages(): void {
    // const images = document.querySelectorAll('.scroll-effect');

    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach(entry => {
    //     const img = entry.target as HTMLElement;
    //     const scrollTop = window.scrollY;
    //     const translateValue = Math.min(scrollTop / 10, 10); // Max move up 30px

    //     if (entry.isIntersecting) {
    //       img.style.transform = `translateY(-${translateValue}px)`;
    //     } else {
    //       img.style.transform = `translateY(0px)`; // Reset when out of view
    //     }
    //   });
    // }, { threshold: 0.3 });

    // images.forEach(img => observer.observe(img));
  }
}
